import pickBy from 'lodash/pickBy'
import identity from 'lodash/identity'

function calculateMaxHeight(initialOffers) {
    const ratesTableContainer = document.querySelector('.rates-table-container')
    const ratesTableContainerMargin = parseInt(window.getComputedStyle(ratesTableContainer)?.marginTop)
    const footerHeight = document.querySelector('footer')?.scrollHeight
    const rateCardSectionHeight = document.querySelector('.rate-card-container')?.scrollHeight * initialOffers
    const formHeight = document.querySelector('.rates-table-form-wrapper')?.scrollHeight
    const filtersHeight = 48

    return ratesTableContainerMargin + footerHeight + rateCardSectionHeight + filtersHeight + formHeight
}

function addHeightStyling() {
    document.querySelector('body').style.height = '100%'
    document.querySelector('html').style.height = '100%'
    document.querySelector('#app').style.height = '100%'
}

function addFormParams(params, store) {
    const territory = process.env.TERRITORY

    if (territory === 'usa') {
        params = {
            ...{
                loan_amount: store.state.apply.internal?.loanAmount?.value,
                loan_purpose: store.state.apply.internal?.loanPurpose?.value,
                state: store.state.apply.internal?.state?.value,
                credit_rating: store.state.apply.internal?.creditRating?.value,
            },
            ...params,
        }
    }

    if (territory === 'gbr' || territory === 'pol' || territory === 'aus') {
        params = {
            ...{
                loan_amount: store.state.apply.internal?.loanAmount?.value,
                loan_purpose: store.state.apply.internal?.loanPurpose?.value,
                loan_term: store.state.apply.internal?.loanTerm?.value,
                residence_status: store.state.apply.internal?.residenceType?.value,
                credit_rating: store.state.apply.internal?.residenceType?.value,
                credit_limit: store.state.apply.internal?.creditLimit?.value,
                card_type: store.state.apply.internal?.cardType?.value,
            },
            ...params,
        }
    }

    return pickBy(params, identity)
}

export { calculateMaxHeight, addHeightStyling, addFormParams }
